import React from 'react';
import { reduxForm } from 'redux-form';
import { Box } from '@mui/material';
import { get } from 'lodash';

import Loader from '../../../../../../common/components/Loader/Loader';
import { Tab, Tabs } from '../../../../../../common/components/Tabs/Tabs';
import Select from '../../../../../../common/components/Select/Select';
import { MenuItem } from '../../../../../../common/components/MenuItem/MenuItem';
import { isMobile } from '../../../../../../common/services/isMobile';
import CommonNavigationPrompt from '../../../../../../common/components/NavigationPrompt/component';

import DemoEdgeControllerDetailsToolbar from '../DemoEdgeControllerDetailsToolbar/DemoEdgeControllerDetailsToolbar';
import EdgeControllerInfoTab from '../../../DemoEdgeControllerInfoTab/ui/DemoEdgeControllerInfoTab';
import DemoEdgeActivities from '../../../DemoEdgeActivities/ui/DemoEdgeActivities';
import EdgeControllerComponentsTab from '../../../DemoEdgeControllerComponentsTab/ui/DemoEdgeControllerComponentsTab';
import EdgeControllerConfigurationTab from '../../../DemoEdgeControllerConfigurationTab/ui/DemoEdgeControllerConfigurationTab';
import EdgeControllerPlazaTab from '../../../DemoEdgeControllerPlazaTab/ui/DemoEdgeControllerPlazaTab';
import EdgeControllerMonitoringTab from '../../../DemoEdgeControllerMonitoringTab/ui/DemoEdgeControllerMonitoringTab';

import { EDGE_CONTROLLER_ALL_TABS as EDGE_CONTROLLER_TABS } from '../../../../../../common/constants/commonConstants';

export const FORM_NAME = 'edgeControllerDetailsForm';

function DemoEdgeControllerDetailsForm({
  handleSubmit,
  currentEdgeControllerData = null,
  activeTabValue,
  selectTab,
  isFetching = false,
  readOnly = true,
  dirty = false,
  ...restProps
}) {
  const props = {
    handleSubmit,
    currentEdgeControllerData,
    activeTabValue,
    selectTab,
    isFetching,
    readOnly,
    dirty,
    ...restProps,
  };

  const edgeControllerId = get(currentEdgeControllerData, 'edgeControllerId');

  const onTabChange = (event, tab) => {
    selectTab(tab);
  };

  const mobileTabChange = (event) => {
    selectTab(event.target.value);
  };

  const tabsHeader = !isMobile && (
    <Box className="edge-controller-details-tabs" display="flex" justifyContent="center" width="100%" bgcolor="rgba(39, 94, 99, 0.1)">
      <Tabs variant="scrollable" centered={false} value={activeTabValue} onChange={onTabChange}>
        {EDGE_CONTROLLER_TABS.map((tab) => (
          <Tab key={tab.value} label={tab.label} value={tab.value} />
        ))}
      </Tabs>
    </Box>
  );

  const tabPanelContent = isFetching ? (
    <Loader />
  ) : (
    <>
      {activeTabValue === 'details' && <EdgeControllerInfoTab edgeControllerId={edgeControllerId} {...props} />}
      {activeTabValue === 'activities' && edgeControllerId && <DemoEdgeActivities edgeControllerId={edgeControllerId} {...props} />}
      {activeTabValue === 'components' && <EdgeControllerComponentsTab edgeControllerId={edgeControllerId} {...props} />}
      {activeTabValue === 'configuration' && <EdgeControllerConfigurationTab edgeControllerId={edgeControllerId} {...props} />}
      {activeTabValue === 'plaza' && <EdgeControllerPlazaTab edgeControllerId={edgeControllerId} {...props} />}
      {activeTabValue === 'monitoring' && <EdgeControllerMonitoringTab edgeControllerId={edgeControllerId} {...props} />}
    </>
  );

  const mobileTabMenu = isMobile && (
    <Select
      className="edge-controller-details-tabs tab-select select-big-icon"
      style={{ width: 260 }}
      value={activeTabValue}
      onChange={mobileTabChange}
    >
      {EDGE_CONTROLLER_TABS.map((tab) => (
        <MenuItem key={tab.value} value={tab.value}>
          {tab.label}
        </MenuItem>
      ))}
    </Select>
  );

  return (
    <>
      <DemoEdgeControllerDetailsToolbar {...props} />

      <form id="edgeControllerDetailsForm" noValidate onSubmit={handleSubmit}>
        <CommonNavigationPrompt when={!readOnly && dirty} />

        {isMobile && mobileTabMenu}

        {tabsHeader}

        <div className="edge-controller-details-form">{tabPanelContent}</div>
      </form>
    </>
  );
}

const DemoEdgeControllerDetails = reduxForm({
  form: FORM_NAME,
  enableReinitialize: true,
  keepDirtyOnReinitialize: false,
})(DemoEdgeControllerDetailsForm);

export default DemoEdgeControllerDetails;
